import { graphql } from "@/graphql/codegen"
import "@/screens/Products/components/Product/Quality/TestTemplates/graphql/fragments"

graphql(`
  query GetCustomerAssociatedTestTemplateList($productId: Int!, $companyId: UUID!, $locationId: UUID!) {
    associatedTestTemplate {
      list(
        input: {
          filter: { productId: $productId, companyId: $companyId, locationId: $locationId }
          sort: { field: SEQUENCE_NUMBER, order: ASC }
        }
      ) {
        ... on AssociatedTestTemplateListOutputSuccess {
          associatedTestTemplates {
            ...AssociatedTestTemplateFields
          }
        }
        ... on AssociatedTestTemplateListOutputFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
